import React, {useEffect, useState} from 'react';
import Container from 'react-bootstrap/Container';
import Alert from 'react-bootstrap/Alert';

import ContentListComponent from './components/ContentListComponent';
import {ContentService} from './services/ContentService';
import Login from './components/Login';


import './App.css';
import {Col, Row} from 'react-bootstrap';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlusCircle} from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import pako from "pako/dist/pako.esm.mjs";


export default class App extends React.Component {
    constructor(props) {
        super(props);
        this.contentService = new ContentService('/h5p');
        this.parentUrl = process.env.REACT_APP_PARENT_URL ?? '';
    }
    private contentService: ContentService;
    private parentUrl: string;
    public state: {
        loggedIn: boolean;
        contentId: string;
        playing: boolean;
        zzz: string;
        role: number;
    } = {
        loggedIn: false,
        contentId: '-',
        playing: false,
        zzz: 'editor',
        role: 0
    };
    public async componentDidMount(): Promise<void> {
        window.addEventListener('message', this.receiveMessage, false);

        const payload = { loaded: true, contentHeight: window.outerHeight };
        window.parent.postMessage({ type: 'callParentFunction', payload }, this.parentUrl);

        // 🔥 Lấy param từ URL
        const { userId, role, contentId } = this.getQueryParams();
        console.log("URL PARAMS =", userId, role, contentId);

        // Nếu có role + userId → tự login
        if (userId && role) {

            const loginUser =
                role === "12" ? `student${userId}` : `teacher${userId}`;

            const ok = await this.loginInternal(loginUser, "Player");  // 🔥 CHỜ login xong
            if (ok) {
                this.setState({ role: Number(role) });

                // Nếu có contentId → mở nội dung ngay sau khi login xong
                if (contentId) {
                    this.setState({
                        contentId,
                        playing: true,
                        zzz: "player"
                    });

                    this.getH5PContent(contentId); // 🔥 Lúc này chắc chắn đã login
                }
            }
        }

        // Resize iframe nếu cần
        let frameHeight = 0;
        const interval = setInterval(() => {
            const h5pIframe = document.getElementsByTagName('iframe')[0];
            if (h5pIframe && frameHeight !== h5pIframe.clientHeight) {
                const payload = { contentHeight: h5pIframe.clientHeight };
                window.parent.postMessage({ type: 'callParentFunction', payload }, this.parentUrl);
                frameHeight = h5pIframe.clientHeight;
            }
        }, 500);
    }

    private getQueryParams() {
        const params = new URLSearchParams(window.location.search);
        let bgInfoCompress = params.get("code");
        if (bgInfoCompress) {
            let bgInfo = JSON.parse(this.decodeAndDecompress(bgInfoCompress));
            //console.log(bgInfo);
            return {
                userId: bgInfo.studentId,
                role: bgInfo.role,
                contentId: bgInfo.contentId
            };
        }
        return {};
    }
    public componentWillUnmount() {
        window.removeEventListener('message', this.receiveMessage, false);
    }
    public decodeAndDecompress(encodedData) {
        // Giải mã từ URI component
        const base64Data = decodeURIComponent(encodedData);
        // Giải mã base64 thành chuỗi Uint8Array
        const binaryString = atob(base64Data);
        const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
        // Giải nén dữ liệu
        const decompressedData = pako.ungzip(byteArray, {to: 'string'});
        return decompressedData;
    }
    private  getH5PContent = (contentId) => {
        fetch(`/h5p/${contentId}/play`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                console.log(data); // Xử lý data từ API
                const payload = {key: 'lesson-data', value: data};
                window.parent.postMessage({type: 'callParentFunction', payload}, this.parentUrl);
                // Lưu data vào state hoặc thực hiện hành động khác
            })
            .catch((error) => {
                console.error('Error fetching data:', error);
            });
    }
    private loginInternal = async (username, type) => {
        try {
            const res = await fetch('/login', {
                method: 'POST',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-type': 'application/json'
                },
                body: JSON.stringify({
                    username: username,
                    password: username.includes('student') ? 'student' : 'admin'
                })
            });

            if (res.status === 200) {
                const loginData = await res.json();

                this.setState({
                    ...this.state,
                    loginData,
                    loginMessage: undefined,
                    loggedIn: true
                });

                if (loginData.csrfToken) {
                    this.contentService.setCsrfToken(loginData.csrfToken);
                }

                return true; // 🔥 LOGIN OK
            } else {
                this.setState({ loggedIn: false });
                return false;
            }
        } catch (err) {
            this.setState({ loggedIn: false });
            return false;
        }
    };
    private login = (username, type) => {
        fetch('/login', {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-type': 'application/json'
            },
            body: JSON.stringify({
                username: username,
                password:  username.includes('student') ? 'student' : 'admin'
            })
        })
            .then(async (res) => {
                if (res.status === 200) {
                    const loginData = await res.json();
                    //console.log(loginData);
                    this.setState({
                        ...this.state,
                        loginData,
                        loginMessage: undefined
                    });
                    if (loginData.csrfToken) {
                        this.contentService.setCsrfToken(
                            loginData.csrfToken
                        );
                        const payload = {key: 'csrfToken' + type, value: loginData.csrfToken};
                        console.log('----------post login token', loginData.csrfToken);
                        window.parent.postMessage({type: 'callParentFunction', payload}, this.parentUrl);
                    }
                    this.setState({loggedIn: true});
                } else {
                    this.setState({
                        ...this.state,
                        loginData: undefined,
                        loginMessage: await res.text()
                    });
                    this.contentService.setCsrfToken(undefined);
                    this.setState({loggedIn: false});
                }
            })
            .catch((reason) => {
                this.setState({
                    ...this.state,
                    loginData: undefined,
                    loginMessage: reason
                });
                this.contentService.setCsrfToken(undefined);
                this.setState({loggedIn: false});
            });
    };
    logout = () => {
        fetch('/logout', {
            method: 'POST',
            headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-type': 'application/json',
                'CSRF-Token': this.contentService.getCsrfToken() ?? ''
            },
            body: JSON.stringify({})
        })
            .then(() => {
                this.setState({
                    ...this.state,
                    loginData: undefined,
                    loginMessage: undefined
                });
                this.contentService.setCsrfToken(undefined);
                this.setState({loggedIn: false});
            })
            .catch((reason) => {
                this.setState({
                    ...this.state,
                    loginData: undefined,
                    loginMessage: `Error logging out: ${reason}`
                });
                this.contentService.setCsrfToken(undefined);
                this.setState({loggedIn: false});
            });
    };
    private allowOrigin(url: string){
        if (url.includes('4200') || url.includes('lms.mschool.edu.vn') || url.includes('lms2.mschool.edu.vn') || url.includes('nguyenkienan'))
        return true;
    }
    private receiveMessage = (event) => {
        //console.log(event.origin, this.parentUrl);
        if (!this.allowOrigin(event.origin)) {
            return;
        }
        //console.log('Message from Angular:', event.data);
        if (event.data.type === 'setContentId') {
            this.setState({
                ...this.state,
                contentId: event.data.contentId,
            });

        } else if (event.data.type === 'playContentId') {
            this.setState({
                ...this.state,
                contentId: event.data.contentId, playing: true, zzz: 'player'
            });
            this.getH5PContent(event.data.contentId);
        } else if (event.data.type === 'doLoginPlayer') {
            console.log('doLoginPlayer', event.data);
            //console.log(event.data.userId);
            this.setState({
                ...this.state,
                role: event.data.role
            });
            //this.login('teacher' + event.data.userId, 'Player');
            this.login(event.data.role == 12 ?  `student${event.data.userId}` : `teacher${event.data.userId}`, 'Player');
        }
        else if (event.data.type === 'doLoginEditor') {
            this.login('teacher' + event.data.userId, 'Editor');
        }
        else if (event.data.type === 'whenParentScroll'){
            let h5pIframe = document.getElementsByTagName('iframe')[0];
            h5pIframe.setAttribute('data-position', event.data.scrollBottom + 150);
            // @ts-ignore
            this.loadWIRIS();

        }
        // Send a response back to Angular
        //event.source.postMessage('Hello from React!', event.origin);
    };

    protected loadWIRIS(){
        /*let h5pIframe = document.getElementsByTagName('iframe')[0];
        // @ts-ignore
        let iframeDoc = h5pIframe.contentDocument || h5pIframe.contentWindow.document;
        let scripts = iframeDoc.getElementsByClassName('wiris-plugin-new');
        if (h5pIframe) {
            let script1 = iframeDoc.createElement('script');
            script1.src = 'https://www.wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image';
            script1.setAttribute("class", "wiris-plugin-new");
            iframeDoc.head.appendChild(script1);
        }*/
    }

    protected edit() {
        const p = prompt('id bài giảng', '3026932575');
        this.setState({
            ...this.state,
            contentId: p, playing: false, zzz: 'editor'
        });
    }

    protected view() {
        const p = prompt('id bài giảng', '3026932575');
        this.setState({
            ...this.state,
            contentId: p, playing: true, zzz: 'player'
        });
    }

    render() {
        return (
            <div className="App">
                <Container>
                    {/*<Row>
                        <Col md="auto" className="m-2">
                            <Login
                                contentService={this.contentService}
                                onLoggedIn={() => {
                                    this.setState({ loggedIn: true });
                                }}
                                onLoggedOut={() => {
                                    this.setState({ loggedIn: false });
                                }}
                            />
                        </Col>
                    </Row>*/}
                    {/*<Button
                        variant="primary"
                        onClick={() => this.edit()}
                        className="my-2"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2"/>
                        Sửa bài giảng 4
                    </Button>
                    &nbsp;&nbsp;&nbsp;
                    <Button
                        variant="primary"
                        onClick={() => this.view()}
                        className="my-2"
                    >
                        <FontAwesomeIcon icon={faPlusCircle} className="me-2"/>
                        Xem bài giảng
                    </Button>*/}

                    {this.state.loggedIn && this.state.contentId ? (
                        <ContentListComponent
                            role={this.state.role}
                            playing={this.state.zzz}
                            contentId={this.state.contentId}
                            contentService={this.contentService}
                        ></ContentListComponent>
                    ) : undefined}
                </Container>
            </div>
        );
    }
}
